export class NeoPropuesta {
  constructor(
    public idPropuesta: Number,
    public cuota: Number,
    public plazo: Number,
    public tasa: Number,
    public origenRecursos: String,
    public monto: Number,
    public idParametrizacionLinea: Number,
    public idLineaBancoldex: Number,
    public idDestino: Number,
    public periodicidad: Number,
    public periodoGracia: Number,
    public puntosAdicionales: Number,
    public observaciones: String,
    public desembolsoAproximado: Number,
    public margenIntermediario: Number,
    public tasaRedescuento: String,
    public codigoTasaRedescuento: Number,
    public modalidad: String,
    public destino: String,
    public idSucursal?:Number
  ) {}
}
